import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VConsole from 'vconsole'
import "amfe-flexible/index" // 引入flexible

Vue.config.productionTip = false

import { Button, Cell, Form, Field, Switch, DatetimePicker, Popup, Picker, Uploader, Toast, List, PullRefresh, Tab, Tabs, Empty, Icon, NoticeBar,RadioGroup,CellGroup,Radio,Checkbox, Overlay, Loading} from 'vant'

[Button, Cell, Form, Field, Switch, DatetimePicker, Popup, Picker, Uploader, Toast, List, PullRefresh, Tab, Tabs,Empty,Icon, NoticeBar,RadioGroup,CellGroup,Radio,Checkbox, Overlay, Loading].forEach(e=>{
  Vue.use(e)
})
import '@babel/polyfill';
import Es6Promise from 'es6-promise';

Vue.use(require('vue-wechat-title'))

import * as voicePromptFun from '@/utils/voicePrompt'
Vue.prototype.voicePrompt = voicePromptFun.voicePrompt

// start build version watcher (auto refresh when new version is released)
import { startVersionWatcher } from '@/utils/version'
startVersionWatcher({ checkIntervalMs: 60000, versionUrl: '/version.json' })

Toast.setDefaultOptions({ duration: 2000 })

if (location.host.indexOf('huoyunren')< 0 && window.location.host.indexOf('hbgszyht') < 0) {
    new VConsole()
}
// 不需要登录的白名单
const whiteLoginList = ['protocol','privacy']
router.beforeEach((to, from, next) => {
  // 验证是否需要登录
  let isLogin = Boolean(localStorage.getItem('g7user'))
    console.log(to, 'to');
  let query = to.query;
  if (isLogin){
     next()
      if(to.path == '//') {
          // 兼容pda登陆后隔断时间地址会出现pda.test.chinawayltd.com//问题
          next({path: '/', query})
      }
  } else {
    if(whiteLoginList.includes(to.name)){
      next()
    }else{
      if (to.path === '/login'){
        next()
      }else{
        next({path: '/login', query})
      }
    }

  }
})
Toast.setDefaultOptions({ duration: 3000 });

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
console.log('我是线上构建');
